// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// Copyright (c) Utrecht University (Department of Information and Computing Sciences)

import axios from "axios";
import { store } from "@/store";
import * as types from "@/utils/Types";

/**
 * Gets the saved code of a student for a level for the teacher
 * @param bundleId Bundle that contains the level
 * @param levelId Level from which you want to get the saved code
 * @param studentId Id of the student
 * @returns The currently saved solution of the given student for the given level and given bundle
 */
async function getStudentSolution(
  bundleId: number,
  levelId: number,
  studentId: number
): Promise<types.levelSave | null> {
  try {
    const res = await axios.get<types.levelSave>(
      `/Progress/GetStudentProgress/${bundleId}/${levelId}/${studentId}`
    );
    store.commit("setCode", res.data.code);
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
}

/**
 * Gets a list of all statistics of a user
 * @returns A list of all statistics of a user
 */
async function getStats(): Promise<types.stats | null> {
  try {
    const res = await axios.get<types.stats>(`/Progress/Stats`);
    store.commit("setStats", res.data);
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
}

/**
 * Gets a bunch of statistics for the given student(s), bundle and level(s)
 * @param bundleId bundle that the statistics are tied to
 * @param studentIds student to get the statistics from
 * @param levelIds level that the statistics are tied to
 * @returns A levelStatsStudent object containing all the required statistics
 */
// async function getStudentStats(
//   bundleId: number,
//   studentIds: number[],
//   levelIds: number[]
// ): Promise<types.levelStatsStudent | null> {
//   console.log("getstatsstudents");
//   console.log("bundleid:", bundleId);
//   console.log("studentids:", studentIds);
//   console.log("levelids:", levelIds);
//   try {
//     const res = await axios.post<
//       | { bundleId: number; studentIds: number[]; levelIds: number[] }
//       | types.levelStatsStudent
//     >(
//       `/Progress/GetStudentStats`,
//       {
//         bundleId: bundleId,
//         studentIds: studentIds,
//         levelIds: levelIds,
//       },
//       {
//         headers: { "Content-Type": "application/json" },
//       }
//     );
//     return res.data as types.levelStatsStudent;
//   } catch (err) {
//     console.error(err);
//     return null;
//   }
// }
async function getStudentStats(
  studentIds: number | number[],
  bundleId: number,
  levelIds: number | number[]
): Promise<types.levelStatsStudent | null> {

  // Verwerk studentIds en levelIds om er zeker van te zijn dat ze als comma-separated strings worden verstuurd
  const studentIdsParam = Array.isArray(studentIds) ? studentIds.join(',') : studentIds.toString();
  const levelIdsParam = Array.isArray(levelIds) ? levelIds.join(',') : levelIds.toString();

  // Bouw de query string
  const queryParams = new URLSearchParams({
    bundleId: bundleId.toString(),
    studentIds: studentIdsParam,
    levelIds: levelIdsParam,
  }).toString();

  try {
    const res = await axios.get<types.levelStatsStudent>(
      `/Progress/GetStudentStats?${queryParams}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
}




/**
 * Gets the saved code of the user for a level in a bundle
 * @param bundleId The id of the bundle
 * @param levelId The id of the level
 * @returns A save of the current level
 */
async function loadLevelSave(
  bundleId: number,
  levelId: number
): Promise<types.levelSave | null> {
  try {
    const res = await axios.get<types.levelSave>(
      `/Progress/${bundleId}/${levelId}`
    );
    console.log("LOADLEVELSAVE: ", res);
    if (typeof res.data == "string")
      store.commit("setLevelSave", JSON.parse(res.data));
    else store.commit("setLevelSave", res.data);
    return res.data;
  } catch (err) {
    console.error(err);
    store.commit("setLevelSave", "");
    return null;
  }
}

/**
 * Gets the currently attained medal for the given level in the given bundle
 * @param bundleId The id of the bundle
 * @param levelId The id of the level
 * @returns The currently attained medal for the given level in the given bundle
 */
async function getMedal(
  bundleId: number,
  levelId: number
): Promise<string | null> {
  try {
    const res = await axios.get<string>(
      `/Progress/Medal/${bundleId}/${levelId}`
    );
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
}

export {
  getStudentSolution,
  getStats,
  getStudentStats,
  loadLevelSave,
  getMedal,
};
